export default __webpack_public_path__ + "static/media/manual-test-case-management.4f1d1d57.svg";